import { View } from 'react-native';
import React, { useEffect } from 'react';
import { RootStackScreenProps } from '../../core';
import WebView from 'react-native-webview';

const CHWebScreen = ({ navigation, route }: RootStackScreenProps<'CHCallback'>) => {
  const code = route.params && 'code' in route.params ? route.params.code : undefined;
  const authUrl = route.params && 'authUrl' in route.params ? route.params.authUrl : undefined;

  useEffect(() => {
    if (code) {
      // redirect back to Settings
      navigation.replace('Settings', { code });
    }
  }, [code, navigation]);

  if (authUrl) {
    return (
      <>
        <WebView
          userAgent="Mozilla/5.0 (Linux; Android 10; Redmi Note 8 Pro) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.88 Mobile Safari/537.36"
          source={{ uri: authUrl }}
        />
      </>
    );
  }

  return <View />;
};

export default CHWebScreen;
